import PlatformPage from '../PlatformPage';

const ForSquarespace = () => (
  <PlatformPage
    slug="squarespace"
    name="Squarespace"
    title="Website Feedback Tool for Squarespace"
    description="Visual feedback on your live Squarespace site. One snippet in Code Injection, works with Squarespace’s Ajax page loading. Invisible to visitors."
    h1="Website feedback tool built for Squarespace sites."
    intro="Paste one line into Code Injection and your team can click on any element of the live site to leave a note pinned to that spot. Cayda understands how Squarespace swaps pages, so notes show up on every page, not just the first one loaded."
    requirement="Code Injection is available on Squarespace Business plans and higher."
    steps={[
      { title: 'Copy your snippet from the Cayda dashboard', desc: 'One script tag with your site’s token.' },
      { title: 'Open Settings → Advanced → Code Injection', desc: 'In your Squarespace admin panel.' },
      { title: 'Paste into the Header field and save', desc: 'Header, so the script is ready before Squarespace’s page transitions start.' },
    ]}
    stepsNote="Use Code Injection, which is site-wide, rather than a Code Block. Code Blocks only load on the page they are placed on."
    loads={{
      title: 'Built for how Squarespace pages load',
      paragraphs: [
        'Squarespace loads pages with its internal Ajax system, Mercury, which swaps content without a full browser reload. Most embedded scripts run once on the first page and never fire again. Cayda listens for Mercury’s own transition events, so when someone navigates it cleans up the previous page’s notes and loads the right ones for the new URL. You do not need to disable Ajax loading.',
        'If a transition rebuilds part of the page and removes Cayda’s interface, it notices within a second, rebuilds itself and reloads the notes. Your session stays signed in.',
      ],
    }}
    where={{
      title: 'Where your team leaves notes',
      paragraphs: [
        'Pages, blog posts, product pages on Squarespace Commerce, index and landing pages. A gallery image that needs replacing, a heading that breaks on mobile, a button that links to the wrong place, copy the client has not signed off. Click it, type, and the note is pinned with a screenshot, the URL, browser, OS and viewport.',
        'Notes have a type, status, priority and assignee and live in a Kanban or list dashboard across all your sites. Designers managing several Squarespace clients keep each as its own site; on the Team plan clients review through guest links at no member fee.',
      ],
    }}
    extras={[
      {
        title: 'Invisible to your visitors',
        paragraphs: [
          'The script activates only for authenticated team members and invited guests. For everyone else it renders nothing, sets no cookies and adds no meaningful weight, so you can review the live site without touching what your audience sees.',
        ],
      },
    ]}
    ctaTitle="Add feedback to your Squarespace site."
    ctaSub="Paste the snippet into Code Injection and start leaving notes in under two minutes."
  />
);

export default ForSquarespace;
